import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { HomeIcon, UserIcon, SettingsIcon, SearchIcon, BellIcon, MailIcon, CalendarIcon, FileTextIcon, ImageIcon, MapPinIcon, ShoppingCartIcon, HeartIcon } from 'lucide-react';
const icons = [{
  Icon: HomeIcon,
  name: 'Home'
}, {
  Icon: UserIcon,
  name: 'User'
}, {
  Icon: SettingsIcon,
  name: 'Settings'
}, {
  Icon: SearchIcon,
  name: 'Search'
}, {
  Icon: BellIcon,
  name: 'Bell'
}, {
  Icon: MailIcon,
  name: 'Mail'
}, {
  Icon: CalendarIcon,
  name: 'Calendar'
}, {
  Icon: FileTextIcon,
  name: 'File'
}, {
  Icon: ImageIcon,
  name: 'Image'
}, {
  Icon: MapPinIcon,
  name: 'Location'
}, {
  Icon: ShoppingCartIcon,
  name: 'Cart'
}, {
  Icon: HeartIcon,
  name: 'Heart'
}];
export function IconographySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="iconography" ref={ref} className="min-h-screen px-8 py-24" data-id="element-1427">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="max-w-7xl mx-auto" data-id="element-1428">
        <div className="mb-16" data-id="element-1429">
          <div className="font-mono text-xs text-[var(--text-muted)] tracking-wider mb-4" data-id="element-1430">
            05 / ICONOGRAPHY
          </div>
          <h2 className="font-bricolage text-5xl md:text-6xl font-semibold" data-id="element-1431">
            Icon System
          </h2>
          <p className="text-lg text-[var(--text-muted)] mt-4 max-w-2xl" data-id="element-1432">
            Lucide icon set — 1.5px stroke, rounded caps, 24px grid. Pairs with
            the metro-line stroke weight.
          </p>
        </div>

        <div className="bg-white rounded-sm border border-[var(--divider)] p-12" data-id="element-1433">
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8" data-id="element-1434">
            {icons.map(({
            Icon,
            name
          }, index) => <motion.div key={name} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {}} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="flex flex-col items-center gap-3 group cursor-pointer" data-id="element-1435">
                <div className="w-16 h-16 flex items-center justify-center rounded-sm border border-[var(--divider)] group-hover:border-[var(--accent-blue)] group-hover:bg-[var(--accent-blue)] group-hover:bg-opacity-5 transition-all" data-id="element-1436">
                  <Icon className="w-6 h-6 text-[var(--text-ink)] group-hover:text-[var(--accent-blue)] transition-colors" strokeWidth={1.5} data-id="element-1437" />
                </div>
                <div className="text-xs text-[var(--text-muted)] text-center" data-id="element-1438">
                  {name}
                </div>
              </motion.div>)}
          </div>

          <div className="mt-12 pt-8 border-t border-[var(--divider)]" data-id="element-1439">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm" data-id="element-1440">
              <div data-id="element-1441">
                <div className="font-mono text-xs text-[var(--text-muted)] mb-2" data-id="element-1442">
                  STROKE WEIGHT
                </div>
                <div data-id="element-1443">1.5px</div>
              </div>
              <div data-id="element-1444">
                <div className="font-mono text-xs text-[var(--text-muted)] mb-2" data-id="element-1445">
                  STYLE
                </div>
                <div data-id="element-1446">Rounded caps and joins</div>
              </div>
              <div data-id="element-1447">
                <div className="font-mono text-xs text-[var(--text-muted)] mb-2" data-id="element-1448">
                  RELATION TO BRAND
                </div>
                <div data-id="element-1449">
                  Same stroke philosophy as the transit-map illustrations —
                  thin, confident, geometric.
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}